import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';

import { BasemapComponent } from '../basemap/basemap.component';
import { State, ControlStatusService } from '../shared/control-status.service';
import { MapLayerControl } from './map-layer-control';
import { EsriLoadService, LoadedModules } from '../shared/esri-load-control.service';
import { GraphicService } from '../shared/graphic.service';
import { RouteService } from '../shared/route.service';
import { ApiConService } from '../shared/api-con.service';
import { IconService } from '../shared/icon.service';
import { CookieService } from 'ngx-cookie-service';
import { NgIf } from '@angular/common';

let mapControl: any;
let drawMap: any;
declare var jquery: any;
declare var $: any;

@Component({
    selector: 'rota-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.css'],
    standalone: true,
    imports: [BasemapComponent, NgIf]
})
export class MapComponent implements OnInit {
  public map: any;
  public view: any;
  public layers: any[] = [];
  public listDetailsService: any;
  @ViewChild(BasemapComponent) baseMapGallery: BasemapComponent;
  private _drawActive: boolean = false;
  mostrarTabela = false;
  public emAbertoURL
  public noClienteURL
  public entregaIniciadaURL
  public voltoDepoisURL
  public naoEntregueURL
  public entregueURL
  public comOcorrenciaURL
  public entregaParcialURL
  public alertaDuploURL
  public riscoAlagamento
  public riscoFurtoRoubo

  constructor(
    public controlStatus: ControlStatusService,
    private esriLoadService: EsriLoadService,
    private graphicService: GraphicService,
    private chRef: ChangeDetectorRef,
    private routeService: RouteService,
    private apiConService: ApiConService,
    public iconService: IconService,
    private cookieService: CookieService
  ) {
    mapControl = this;
  }

  ngOnInit() {
    this.emAbertoURL = this.iconService.iconeCliente(0, 0, false, false);
    this.noClienteURL = this.iconService.iconeCliente(0, 1, false, false);
    this.entregaIniciadaURL = this.iconService.iconeCliente(0, 2, false, false);
    this.voltoDepoisURL = this.iconService.iconeCliente(0, 3, false, false);
    this.naoEntregueURL = this.iconService.iconeCliente(0, 4, false, false);
    this.entregueURL = this.iconService.iconeCliente(0, 5, false, false);
    this.comOcorrenciaURL = this.iconService.iconeCliente(0, null, true, false);
    this.entregaParcialURL = this.iconService.iconeCliente(0, null, false, true);
    this.alertaDuploURL = this.iconService.iconeCliente(0, null, true, true);
    this.riscoAlagamento = this.iconService.iconeCliente(0,0,false,false,false,false,'ALAGAMENTO')
    this.riscoFurtoRoubo = this.iconService.iconeCliente(0,0,false,false,false,false,'FURTO/ROUBO')
    const mapas = {
      '4': 'satellite',
      '5': 'hybrid',
      '6': 'streets-vector',
      '7': 'streets-relief-vector',
      '8': 'streets-navigation-vector',
      '9': 'streets-night-vector',
      '10': 'terrain',
      '11': 'gray-vector',
      '12': 'dark-gray',
      '13': 'oceans',
      '14': 'national-geographic',
      '15': 'osm',
      '18': 'streets-night-vector',
      '21': 'dark-gray-vector'
    };
    
    this.esriLoadService.loadClass()
      .then(() => {
        let mapaEscolhido = this.cookieService.get('mapaEscolhido');
        if (!mapaEscolhido) {
          mapaEscolhido = "streets-vector";
        } 
        this.map = new LoadedModules.Map(
          {
            basemap: mapaEscolhido, 
          }
        );

        this.view = new LoadedModules.MapView({
          container: "map",
          center: [-51.717218, -11.824602],
          zoom: 4,
          map: this.map,
          popup: {
            dockEnabled: false,
            dockOptions: {
              buttonEnabled: false,
              breakpoint: false
            },
            visibleElements: {
              closeButton: false
            }
          },
        });

        const basemapGallery = new LoadedModules.BasemapGallery({
          view: this.view,
          container: document.createElement("div")
        });

        const bgExpand = new LoadedModules.Expand({
          view: this.view,
          content: basemapGallery
        });
        LoadedModules.ReactiveUtils.watch(
          () => basemapGallery.activeBasemap,
          () => {
            let mapaEscolhido = basemapGallery.activeBasemap.id;
            let posicaoUltimoHifen = mapaEscolhido.lastIndexOf("-");
            let id = mapaEscolhido.slice(posicaoUltimoHifen + 1);

            if (mapas[id]) {
              mapaEscolhido = mapas[id];
            } else {
              mapaEscolhido = 'streets-vector';
            }
            this.cookieService.set('mapaEscolhido', mapaEscolhido);
            const mobileSize =
              this.view.heightBreakpoint === "xsmall" ||
              this.view.widthBreakpoint === "xsmall";
            if (mobileSize) {
              bgExpand.collapse();
            }
          }
        );
        this.view.ui.add(bgExpand, "top-right");
        this.view.ui.move("zoom", "bottom-right");

        mapControl.graphicService.map = this.map;
        mapControl.graphicService.view = this.view;
        mapControl.graphicService.iniLayers();

        this.view.on("pointer-move", (() => {
          let timeout: any = null;
          let ultimoGraphicHover: any = null;
          let posicaoPopup: { x: number, y: number } = null; // onde o popup abriu (coords de tela)
          const RAIO_SAIDA = 30; // px de tolerância antes de fechar o popup
          const mapEl = document.getElementById("map"); // busca no DOM uma única vez
          let ultimoCursor = '';

          const setCursor = (cursor: string) => {
            if (cursor !== ultimoCursor) { 
              mapEl.style.cursor = cursor;
              ultimoCursor = cursor;
            }
          };

          const fecharPopup = () => {
            mapControl.graphicService.view.closePopup();
            ultimoGraphicHover = null;
            posicaoPopup = null;
            setCursor("context-menu");
          };

          return (event) => {
            // Fechamento imediato: o mouse saiu do raio do ponto onde o popup
            if (posicaoPopup) {
              const dx = event.x - posicaoPopup.x;
              const dy = event.y - posicaoPopup.y;
              if (dx * dx + dy * dy > RAIO_SAIDA * RAIO_SAIDA) {
                fecharPopup();
              }
            }

            clearTimeout(timeout);
            timeout = setTimeout(() => {
              mapControl.graphicService.view.hitTest(event, {
                include: mapControl.graphicService.view.map.layers.toArray()
              }).then((response) => {
                const result = response.results.find((r: any) =>
                  r.graphic && r.graphic.layer && r.graphic.layer.type === "graphics"
                );

                if (!result) {
                  if (ultimoGraphicHover) fecharPopup(); else setCursor("context-menu");
                  return;
                }

                const graphic = (result as any).graphic;

                // mesmo graphic do último hover: popup já está aberto
                if (graphic === ultimoGraphicHover) return;

                if (
                  graphic &&
                  graphic.geometry &&
                  !mapControl.routeService.exibePopup &&
                  (graphic.popupTemplate || graphic.attributes) &&
                  (!graphic.attributes || !graphic.attributes.hasOwnProperty('PontoInicial'))
                ) {
                  setCursor("pointer");
                  ultimoGraphicHover = graphic;
                  posicaoPopup = { x: event.x, y: event.y };
                  mapControl.graphicService.view.openPopup({
                    features: [graphic],
                    location: graphic.geometry?.centroid ?? graphic.geometry
                  });
                } else {
                  if (ultimoGraphicHover) fecharPopup(); else setCursor("context-menu");
                }
              });
            }, 80);
          };
        })());

        this.getRouter();
    });


    

  }

acessarRoteiro(numeroRoteiro: number)
{
  this.graphicService.numeroRoteiroAcesso = numeroRoteiro;
  document.getElementById("btnVisualizarRoteiro").click();
}

loadGallery() {
  this.baseMapGallery.map = this.map;
  this.baseMapGallery.view = this.view;
  this.baseMapGallery.iniciaBaseMapaGallery();
}

  async getRouter()
{
}
}
